import styled from 'styled-components';

export const FormControl = styled.div`
  position: relative;
`;
